const profile = {
    title: 'Кабинет',
    myAddress: 'Мои адреса',
    historyOrders: 'История заказов',
    messages: 'Чат с поддержкой',
    bonuses: 'Ваши баллы',
    share: 'Поделиться ссылкой',
    delivery: 'Доставка и оплата',
    aboutCompany: 'О компании',
    downloadApp: 'Скачать приложение',
    signOut: 'Выйти из профиля',
    btnLogoutOk: 'Да, выйти',
    deleteAccount: 'Удалить аккаунт',
    modalDeleteAccount: {
        title: 'Удалить аккаунт?',
        btnDelete: 'Да',
        btnClose: 'Нет',
    },
    messageSignOut: 'При выходе из профиля все товары удалятся из корзины. Выйти из профиля?',
    userPlaceholder: 'Имя пользователя',
    emailPlaceholder: 'email',
    copy: 'Ссылка скопирована',
    history: {
        repeat: 'Повторить заказ',
        more: 'Подробнее',
        order: 'Заказ №',
        cancel: 'Отменить заказ',
        amount: 'Стоимость: ',
        deliveryAmount: 'Доставка: ',
        quantity: 'Количество: ',
    },
    agreements: {
        ads: {
            labels: {
                bannerTitle: 'Хотите знать о времени прибытия курьера, акциях и скидках?',
                modalText:
                    'Вы соглашаетесь получать рекламные предложения в СМС, пуш-уведомлениях и письмах на почту. Отказаться всегда можно в настройках вашего устройства.',
                checkboxLabel:
                    'Я согласен получать уведомления о статусах заказа, рекламных предложениях и новинках в пушах, смс и на почту',
            },
            buttons: {
                bannerAgree: 'Хочу!',
                bannerDecline: 'Не хочу',
            },
        },
        privacyPolicy: {
            labels: {
                checkboxLabel: 'Я даю согласие на',
            },
            buttons: {
                checkboxDocument: 'обработку персональных данных',
            },
        },
    },
};

export default profile;
